// extracted by mini-css-extract-plugin
export default {"container":"AuthorLog_container__WLMwb"};